import User from "../../types/User";

const userDisplayName = (user: Pick<User, "fullName" | "username">) =>
  user.fullName || user.username;
export default userDisplayName;
